(function (doc, win) {
  var docEl = doc.documentElement
  var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
  var recalc = function () {
    var clientWidth = docEl.clientWidth
    if (!clientWidth) return
    if (50 * (clientWidth / 375) < 100) {
      docEl.style.fontSize = 50 * (clientWidth / 375) + 'px'
    } else {
      docEl.style.fontSize = 100 + 'px'
    }
  }
  if (!doc.addEventListener) return
  win.addEventListener(resizeEvt, recalc, false)
  doc.addEventListener('DOMContentLoaded', recalc, false)
})(document, window)



// WEBPACK FOOTER //
// ./src/utils/rem.js